import BatteryInfoCard from 'components/BatteryInfo/BatteryInfoCard';
export default BatteryInfoCard;
